(() => {
  // CUSTOM_salon-form.js
  // cart-drawer.js
  class Main {
    constructor(freeWord, salonType, prefId, areaId, salonId, otherSalonName, refferSalonId) {
      this.free_word = freeWord;
      this.salon_type = salonType;
      this.pref_id = prefId;
      this.area_id = areaId;
      this.salon_id = salonId;
      this.other_salon_name = otherSalonName;
      this.reffer_salon_id = refferSalonId;
      this.area_lists = [];
      this.salon_lists = [];
      this.selectors = {
        inputFreeWord: $("#SalonName"),
        inputSalonType: $("#SalonTypeSelect"),
        inputPref: $('#PrefSelect'),
        inputArea: $('#AreaSelect'),
        inputSalon: $('#SalonSelect'),
        inputOtherSalon: $("#OtherSalonName"),
        elmCheckoutBtn: $("#form-need-salon-submit"),
        elmSalonSelectAlert: $("#not-salon-selected"),
        elmOtherSalon: $("#other_salon_name_field"),
        elmLoading: $("#loading"),
        submitDataSalonId: $("#submit_data_salon_id"),
        submitOtherSalonName: $("#submit_other_salon_name"),
      };
      this.OTHER_SALON_ID = 'no-record';
    };

    initialize = async () => {
      if(this.reffer_salon_id) {
        //サロン選択済みの場合、都道府県、エリアとサロンの選択を自動で行う
        await this.salonIdDataSet(this.reffer_salon_id);
      };

      if (this.pref_id) {
        //都道府県選択済みの場合、エリアリストの出力を自動で行う
        await this.areaListDataSet();
      };
    
      if (this.area_id) {
        //エリア選択済みの場合、サロンリストの出力を自動で行う
        await this.salonListDataSet();
      };
    };

    render = () => {
      this.selectors.elmSalonSelectAlert.removeAttr('style'); //サロン未選択時のアラート表示
      this.selectors.elmOtherSalon.toggle(this.salon_id == this.OTHER_SALON_ID); //選択中のサロンがその他サロンの場合表示
      this.renderAreaLists();
      this.renderSalonLists();
      this.renderInputValue();
      this.renderCheckoutActivable(); //サロン選択済みの場合は登録ボタン活性
    };

    // チェックアウトボタンの活性切り替え
    renderCheckoutActivable = () => {
      const hasSalon = this.salon_id && (this.salon_id != this.OTHER_SALON_ID || (this.salon_id == this.OTHER_SALON_ID && this.other_salon_name));
      const canProceed = hasSalon

      this.selectors.elmCheckoutBtn.prop("disabled", !canProceed);
      this.selectors.elmCheckoutBtn.css({
        "cursor": canProceed ? "unset" : "not-allowed",
        "pointer-events": canProceed ? "unset" : "none"
      });
      this.selectors.elmSalonSelectAlert.css("display", hasSalon ? "none" : "");
    };

    // エリアリスト更新
    renderAreaLists = () => {
      this.selectors.inputArea.empty();
      this.selectors.inputSalon.empty();
      this.selectors.inputSalon.append("<option value=\"\">検索結果を表示</option>");
      this.selectors.inputArea.append("<option value=\"\">エリア選択</option>");
      
      for(var i in this.area_lists) {
          this.selectors.inputArea.append(
              "<option value=" + this.area_lists[i].id + ">" + this.area_lists[i].name + "</option>"
          )
      };
    };

    // サロンリスト更新
    renderSalonLists = () => {
      this.selectors.inputSalon.empty();
      this.selectors.inputSalon.append("<option value=\"\">検索結果を表示</option>");
      for(var i in this.salon_lists) {
        this.selectors.inputSalon.append(
          `<option value="${this.salon_lists[i].uuid}">${this.salon_lists[i].name}</option>`
        );
      };
      this.selectors.inputSalon.append(
        `<option value="no-record">その他</option>`
      );
    };

    // form値DOM更新
    renderInputValue = () => {
      const setSelectedOption = (selector, value) => {
        selector.find(`option[value="${value}"]`).attr("selected", true);
      };

      this.selectors.inputFreeWord.val(this.free_word);
      setSelectedOption(this.selectors.inputSalonType, this.salon_type);
      setSelectedOption(this.selectors.inputPref, this.pref_id);
      setSelectedOption(this.selectors.inputArea, this.area_id);
      setSelectedOption(this.selectors.inputSalon, this.salon_id);
      this.selectors.inputOtherSalon.val(this.salon_id == this.OTHER_SALON_ID ? this.other_salon_name : '');
      this.selectors.submitDataSalonId.val(this.salon_id);
      this.selectors.submitOtherSalonName.val(this.other_salon_name);

      if (!!this.reffer_salon_id) {
        const fields = [
          this.selectors.inputFreeWord,
          this.selectors.inputSalonType,
          this.selectors.inputPref,
          this.selectors.inputArea,
          this.selectors.inputSalon
        ];
      
        fields.forEach(field => {
          field.prop("disabled", true);
          field.css({
            'background-color': '#eee',
            'cursor': 'not-allowed'
          });
        });
        $('.salon-heading').after("<div style=\"font-size:12px;color:red\">QRコードよりサロン情報を読み取っています。サロンの変更はできません</div>");
      }
    };

    // ローカル変数の値変更
    setData = (key, data) => {
      // cookieデータセット
      const setCookie = (name, value) => {
        document.cookie = `${name}=${value}; path=/; Secure; SameSite=None`;
      };
      
      this[key] = data || '';  // 空のデータが入らないようにデフォルト値を設定
      setCookie(`ib_user_regist_${key}`, this[key]);  // クッキーに保存
    };

     // リスト配列の値変更
    setListsData = (key, data) => { 
      this[key] = data || [];  // 空のデータが入らないようにデフォルト値を設定
    };

    // Submitサロンデータのセット
    setSubmitSalonData = () => {
      if (this.salon_id == this.OTHER_SALON_ID) {
        this.selectors.elmOtherSalon.toggle(true);
        this.selectors.submitOtherSalonName.val(this.otherSalonName);
      } else {
        this.selectors.elmOtherSalon.toggle(false);
        this.selectors.submitOtherSalonName.val('');
      }
    };

    // サロンデータ更新
    salonIdDataSet = async (salon_uuid) => {
      this.selectors.elmLoading.toggle(true);
      const url = `${window.IB4BClient.DomainIB4B}/api/v1/ifing_beauty/salons/get_salon?salon_uuid=${salon_uuid}`;

      try {
        const salon = await window.IB4BClient.fetchFourbData(url);
        this.setData("pref_id", salon.prefecture_id);
        this.setData("area_id", salon.area_id);
        this.setData("salon_id", salon.uuid);
      } catch (err) {
        console.error("サロンデータ取得エラー:サロンを選択してください", err);
        //document.cookie = "salon_id=; path=/; max-age=0; Secure; SameSite=None";
      } finally {
        this.selectors.elmLoading.toggle(false);
      }
    }

    // エリアリスト更新
    areaListDataSet = async () => {
      this.selectors.elmLoading.toggle(true);
      const url = `${window.IB4BClient.DomainIB4B}/api/v1/ifing_beauty/salons/get_areas?prefecture_id=${this.pref_id}`;
      
      try {
        const area = await window.IB4BClient.fetchFourbData(url); // APIコール
        this.setListsData("area_lists", area);
        //都道府県に紐づくサロンも出力
        await this.salonListDataSet();
      } catch (err) {
        console.error("エリアリスト取得エラー:", err);
      } finally {
        this.selectors.elmLoading.toggle(false);
      }
    }

    // サロンリストの更新
    salonListDataSet = async () => {
      this.selectors.elmLoading.toggle(true);
      const url = `${window.IB4BClient.DomainIB4B}/api/v1/ifing_beauty/salons/get_salons`;
      
      try {    
        // APIリクエストをawaitで処理
        const salons = await window.IB4BClient.fetchSalonList(url, this.free_word, this.salon_type, this.pref_id, this.area_id);
        // データをセット
        this.setListsData("salon_lists", salons);
      } catch (err) {
        console.error("サロンリスト取得エラー:", err);
      } finally {
        this.selectors.elmLoading.toggle(false);
      };
    };
  };

  // グローバルオブジェクトに登録
  window.SalonForm = {
    Main,
  };
})();